module.exports = __webpack_public_path__ + "img/phone-import.cb23c09d.svg";